import React, { FC } from 'react';
import styled from 'styled-components';
import { SettingsLabelWithoutMargin } from 'components/organisms/module-settings/styles';
import { HelperText01 } from 'ozone/atoms';

interface Props {
  label: string;
  descriptions?: string[];
}

const Container = styled.div`
  display: flex;
`;

const Info = styled.div`
  flex: 0 0 200px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-right: var(--layout-03);
`;

const Label = styled(SettingsLabelWithoutMargin)`
  padding: var(--layout-01);
  padding-left: 0;
  padding-top: 0;
`;

const Description = styled(HelperText01)`
  padding: 0 var(--layout-01) var(--layout-01) 0;
`;

const Control = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  & > * {
    margin-bottom: var(--layout-01);

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const ControlPanel: FC<Props> = ({
  label,
  descriptions = [],
  children,
}) => (
  <Container>
    <Info>
      <Label>{label}</Label>
      {descriptions.map((x) => (
        <Description>{x}</Description>
      ))}
    </Info>
    <Control>{children}</Control>
  </Container>
);
